function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 25690",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M519.69 192.66h398.73a18.6 18.6 0 0118.01 23.25l-62.85 242.95a22.334 22.334 0 01-40.96 5.58L739.45 303.3l-225.6-74.38a18.6 18.6 0 015.84-36.26z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M282.32 0A260.487 260.487 0 0030.14 195.23L4.78 293.32a148.858 148.858 0 00144.17 186.14l261.35-.14 363.78-.14a179.053 179.053 0 00-153.82-88.03H403.68a74.375 74.375 0 01-72.02-93.04l25.12-97.16A148.872 148.872 0 01500.83 89.39h417.63A111.644 111.644 0 001026.5 5.71l1.47-5.67z"
}));

function SvgLogoSmallWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1027.971 479.46"
  }, props), _ref);
}

export default SvgLogoSmallWhite;